import * as Yup from "yup";
import { cfRegex } from "../../../utils/cfRegex";
import { getTodayDate, toEnDateString } from "../../../utils/dateUtils";
import { t } from "i18next";
import { isCustomerDistrictRequired } from "../../../utils/districtUtils";

const todayDate = toEnDateString(getTodayDate());

const getResidenceValidation = (customer) => Yup.object().shape({
    street: Yup.mixed().required("Obbligatorio").nullable(),
    number: Yup.mixed().required("Obbligatorio").nullable(),
    internal: Yup.number().typeError("Inserire un numero valido").nullable(),
    cap: Yup.number().required("Obbligatorio").typeError("Inserire un numero valido").nullable(),
    city: Yup.mixed().required("Obbligatorio").nullable(),
    province: Yup.mixed().required("Obbligatorio").nullable(),
    districtGuid: (process.env.REACT_APP_ENABLE_DISTRICT !== "false") && isCustomerDistrictRequired(customer)
        ? Yup.string().required("Obbligatorio").nullable()
        : Yup.mixed().nullable(),
});

const domicileValidation = Yup.object().shape({
    street: Yup.mixed().required("Obbligatorio").nullable(),
    number: Yup.mixed().required("Obbligatorio").nullable(),
    internal: Yup.number().typeError("Inserire un numero valido").nullable(),
    cap: Yup.number().required("Obbligatorio").typeError("Inserire un numero valido").nullable(),
    city: Yup.mixed().required("Obbligatorio").nullable(),
    province: Yup.mixed().required("Obbligatorio").nullable(),
});

export const formStructureRichiedenteRow = () => ([
    {
        name: "applicant.name",
        label: t("sg.patient.firstName"),
        type: "input",
    },
    {
        name: "applicant.surname",
        label: t("sg.patient.lastName"),
        type: "input",
    },
    {
        name: "applicant.data",
        label: t("sg.patient.requestDate"),
        type: "input",
        dataElement: {
            type: "date",
            max: todayDate,
        },
    },
].map((ele) => ({ ...ele, col: { xs: "12", sm: "6", md: "4", lg: "3" } })));

export const formStructureMedicoRow = (t) => ([
    {
        name: "prescriber.code",
        label: t("sg.order.prescriber.doctorCode"),
        type: "input",
    },
    {
        name: "prescriber.name",
        label: t("sg.order.prescriber.prescriberName"),
        type: "input",
    },
    {
        name: "prescriber.surname",
        label: t("sg.order.prescriber.prescriberSurname"),
        type: "input",
    },
].map((ele) => ({ ...ele, col: { xs: "12", sm: "6", md: "4", lg: "3" } })));

export const formStructurePrescrizioneRow = (t) => ([
    {
        name: "prescription.code",
        label: t("sg.order.prescriber.prescriptionCode"),
        type: "input",
    },
    {
        name: "prescription.date",
        label: t("sg.order.prescriber.prescriptionDate"),
        type: "input",
        dataElement: {
            type: "date",
            max: todayDate,
        },
    },
].map((ele) => ({ ...ele, col: { xs: "12", sm: "6", md: "4", lg: "3" } })));

export const formStructureDiagnosiRow = [
    {
        name: "diagnosis",
        label: t("sg.patient.diagnosis"),
        type: "textarea",
        col: { xs: "12" },
    },
];

export const getValidationsTemplateGenPub = (customer) => Yup.object().shape({
    // applicant: Yup.object().shape({
    // 	name: Yup.string().required("Obbligatorio"),
    // 	surname: Yup.string().required("Obbligatorio"),
    // 	data: Yup.date()
    // 		.max(todayDate, `La data non può essere maggiore di oggi`)
    // 		.required("Obbligatorio"),
    // }),
    prescriber: Yup.object().shape({
        //code: Yup.string().required("Obbligatorio"),
        name: Yup.string().required("Obbligatorio").nullable(),
        surname: Yup.string().required("Obbligatorio").nullable(),
    }),

    prescription: Yup.object().shape({
        date: Yup.date()
            .max(todayDate, `La data non può essere maggiore di oggi`)
            .required("Obbligatorio")
            .nullable(),
    }),

    isDomicileDifferent: Yup.boolean(),
    patient: Yup.object().when("isDomicileDifferent", {
        is: true,
        then: Yup.object().shape({
            residence: getResidenceValidation(customer),
            domicile: domicileValidation,
        }),
        otherwise: Yup.object().shape({
            residence: getResidenceValidation(customer),
            domicile: Yup.object().nullable().notRequired(),
        }),
    }),
});

export const getValidationPatient = (customer) => Yup.object().shape({
    name: Yup.mixed().required("Obbligatorio").nullable(),
    surname: Yup.mixed().required("Obbligatorio").nullable(),
    cf: Yup.string().matches(cfRegex, "Inserire CF valido").nullable(),
    phone: Yup.number()
        .typeError("Inserire un numero valido")
        .required("Obbligatorio")
        .nullable(),
    mobile: Yup.number()
        .typeError("Inserire un numero valido")
        .required("Obbligatorio")
        .nullable(),

    //email: Yup.string().email("Inserire mail valida").required("Obbligatorio").nullable(),

    domicile: Yup.object().shape({
        street: Yup.mixed().required("Obbligatorio").nullable(),
        number: Yup.mixed()
            .required("Obbligatorio")
            .nullable(),
        internal: Yup.number()
            .nullable()
            .typeError("Inserire un numero valido")
            .nullable(),
        cap: Yup.number()
            .typeError("Inserire un numero valido")
            .required("Obbligatorio")
            .nullable(),
        city: Yup.mixed().required("Obbligatorio").nullable(),
        province: Yup.mixed().required("Obbligatorio").nullable(),
    }),

    residence: Yup.object().shape({
        street: Yup.mixed().required("Obbligatorio").nullable(),
        number: Yup.mixed().required("Obbligatorio").nullable(),
        internal: Yup.number().typeError("Inserire un numero valido").nullable(),
        cap: Yup.number().typeError("Inserire un numero valido").nullable(),
        city: Yup.mixed().required("Obbligatorio").nullable(),
        province: Yup.mixed().required("Obbligatorio").nullable(),
        districtGuid: (process.env.REACT_APP_ENABLE_DISTRICT !== "false") && isCustomerDistrictRequired(customer)
            ? Yup.string().required("Obbligatorio").nullable()
            : Yup.mixed().nullable(),
    }),
});

export const getValidationsTemplateGenFar = () => Yup.object().shape({
    delivery: Yup.string().required("Obbligatorio").nullable(),
    deliveryType: Yup.mixed().required("Obbligatorio").nullable(),
});

export const getValidationsTemplateGenFarWithPatient = (customer) => Yup.object().shape({
    delivery: Yup.string().required("Obbligatorio").nullable(),
    patient: getValidationPatient(customer),
});

export const getValidationsTemplateGenFarWithIdPatient = (customer) => Yup.object().shape({
    delivery: Yup.string().required("Obbligatorio").nullable(),
    patient: getValidationPatient(customer),
    deliveryType: Yup.mixed().required("Obbligatorio").nullable(),
});
